'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var marker_dispatcher = {};

exports.__exports = marker_dispatcher;
